import { createPostEndpoint } from '@sonar-software/sonar-http';

export type PostLoginRequest = {
	email: string;
	password: string;
};

export type PostLoginResponse = {
	token: string;
};

export const postLogin = createPostEndpoint<PostLoginRequest, PostLoginResponse>(
	'/api/v3/security/authentication/login'
);
